import { CloseOutlined } from "@ant-design/icons";
import { Button, Collapse, Flex, Form, InputNumber, Select, Space } from "antd";
import React from "react";
import { AnchorSelect } from "./AnchorSelect";
import { Constraint } from "../../types";

interface LayoutConstraintListProps {
  name: (string | number)[];
  constraints?: Constraint[];
  components?: string[];
}

export const LayoutConstraintList = (props: LayoutConstraintListProps) => {
  const initialValue = {
    target: "system",
    value: 0,
    multiplier: 1,
    source_anchor: "ANCHOR_CENTER_X",
    target_anchor: "ANCHOR_CENTER_X",
  };

  const name = (index: number) => {
    const constraint = props.constraints?.[index];
    if (constraint === undefined) {
      return `Constraint ${index + 1}`;
    }

    return `Constraint [${constraint.source_anchor.replace("ANCHOR_", "")} == ${
      constraint.target
    } | ${constraint.target_anchor.replace("ANCHOR_", "")} | ${
      constraint.value
    }] x ${constraint.multiplier}`;
  };

  return (
    <Form.List name={props.name}>
      {(fields, { add, remove }) => (
        <div style={{ display: "flex", rowGap: 16, flexDirection: "column" }}>
          {fields.map((field, index) => (
            <Collapse size="small" key={field.key}>
              <Collapse.Panel
                key={field.name}
                header={name(index)}
                extra={
                  <CloseOutlined
                    
                    onClick={() => {
                      remove(field.name);
                    }}
                  />
                }
              >
                <Space direction="horizontal" size="middle">
                  <Form.Item label="Target" name={[field.name, "target"]}>
                    <Select
                      style={{ minWidth: "250px" }}
                      options={[
                        ...(props.components?.map((component) => ({
                          label: component,
                          value: component,
                        })) ?? []),
                        { label: "system", value: "system" },
                      ]}
                    />
                  </Form.Item>
                  <Form.Item label="Value" name={[field.name, "value"]}>
                    <InputNumber />
                  </Form.Item>
                  <Form.Item
                    label="Multiplier"
                    name={[field.name, "multiplier"]}
                  >
                    <InputNumber addonBefore="x" />
                  </Form.Item>
                </Space>
                <Flex>
                  <Form.Item
                    label="Source"
                    name={[field.name, "source_anchor"]}
                  >
                    <AnchorSelect style={{ minWidth: "350px" }} />
                  </Form.Item>
                  <Form.Item
                    label="Target"
                    name={[field.name, "target_anchor"]}
                  >
                    <AnchorSelect style={{ minWidth: "350px" }} />
                  </Form.Item>
                </Flex>
              </Collapse.Panel>
            </Collapse>
          ))}

          <Button type="dashed" onClick={() => add(initialValue)} block>
            + Add Layout Constraint
          </Button>
        </div>
      )}
    </Form.List>
  );
};
